import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';

const HomePage = lazy(() => import('@/pages/home/page'));
const AboutPage = lazy(() => import('@/pages/about/page'));
const CoursesPage = lazy(() => import('@/pages/courses/page'));
const ContactPage = lazy(() => import('@/pages/contact/page'));
const FAQPage = lazy(() => import('@/pages/faq/page'));
const PrivacyPage = lazy(() => import('@/pages/privacy/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

/**
 * Global Route Configuration
 * Uses lazy loading for all top-level pages to optimize bundle size.
 */
const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'courses',
        element: <CoursesPage />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
      {
        path: 'faq',
        element: <FAQPage />,
      },
      {
        path: 'privacy',
        element: <PrivacyPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;